import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "service-content-modal" }
const _hoisted_2 = { class: "modal-content-mainer" }
const _hoisted_3 = { class: "modal-content-footer" }
const _hoisted_4 = { class: "btn-group-control" }

import { NScrollbar, NButton } from "naive-ui";
import PrivacyPolicyTextContent from "./PrivacyPolicyTextContent.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'PrivacyPolicyContent',
  emits: [
    "onClose",
    "onConfirm",
],
  setup(__props, { emit: __emit }) {

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-content-header" }, [
      _createElementVNode("h1", null, "Privacy Policy")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NScrollbar), { style: {"height":"calc(696px - 96px - 114px)"} }, {
        default: _withCtx(() => [
          _createVNode(PrivacyPolicyTextContent)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(NButton), {
          class: "br30",
          color: '#000000',
          "text-color": "#ffffff",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onConfirm')))
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("I Know")
          ])),
          _: 1
        })
      ])
    ])
  ]))
}
}

})